import { Secret } from "../models/secret";
import { ManageSecretService } from "../services/manage.secret.service";

const SingletonManager = new Map<string, Promise<Secret | null>>();

export const getSecretManager = async (secretId: string) => {
  const normalizedSecretId = secretId?.trim();
  if (!normalizedSecretId) return null;

  if (!SingletonManager.has(normalizedSecretId)) {
    SingletonManager.set(
      normalizedSecretId,
      ManageSecretService.getSecrets()
        .then((response) => {
          if (!response?.data) return null;
          return response.data as Secret;
        })
        .catch(() => {
          return null;
        })
    );
  }

  return await (SingletonManager.get(normalizedSecretId) || Promise.resolve(null));
};
